<template>
<div class="action-items">
    <div id="action-items-overlay" class="d-flex flex-column full-height" style="overflow-x: hidden">
        <busy-indicator />
        <div class="mx-1 my-1 mr-4 position-relative w-100 pr-2">
            <div style="align-items:baseline;">
                <h4 class="mb-1" v-if="!isInternalUser">Action Items</h4>

            </div>
            <div style="display: flex;justify-content: space-around;padding-bottom:5px;padding-top:5px;" v-if="isInternalUser">
              <a href="#" @click.prevent="showMine">Mine</a>
              <a href="#" @click.prevent="showModalSearch">Search</a>
              <a href="#" v-if="showEmployerLink" @click.prevent="showCurrentEmployerItems">{{amfCode}}</a>
              <a href="#" v-if="showEmployeeLink" @click.prevent="showCurrentEmployeeItems">{{fullName}}</a>
              <!-- <div v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div> -->
            </div>
            <amf-button :onClick="reassignMultiple" v-if="multiSelectedCount > 0" class="btn-success mt-1">Reassign {{ multiSelectedCount }} Items</amf-button>
            <amf-button :onClick="deselectAll" v-if="multiSelectedCount > 0" title="Clear selection" class="btn-success mt-1">X</amf-button>
            <div v-if="itemsCount && multiSelectedCount > 0" style="margin-top:5px"></div>

          <div class="dropdown" style="width: 100%;position: initial">
              <div class="input-group" style="width:100%">
                <input
                  v-if="isInternalUser"
                  type="text"
                  v-model="quickSearchText"
                  placeholder="Quick Search"
                  class="form-control py-2 border-right-0 border"
                  v-advertise="'ai-qsearch,9/1/2021'"
                />
                <div class="input-group-append" v-if="isInternalUser">
                  <button
                    :class="['btn', 'btn-secondary', {'quicksearch-open': this.quickSearchDropDownVisible}]"
                    type="button"
                    @click.prevent="showQuickSearchDropdown"
                    v-advertise="'ai-contextual-search,01/05/2021'"
                  >
                      <i :class="['fa', { 'fa-chevron-down': !this.quickSearchDropDownVisible }, { 'fa-chevron-up': this.quickSearchDropDownVisible}]"></i>
                  </button>
                </div>
              </div>

              <div class="quicksearch-dropdown w-100" v-if="quickSearchDropDownVisible && isInternalUser">
                <div class="p-2">

                  <div class="form-group">
                    <select
                      class="form-control"
                      id="contextualUserDropdown"
                      @change="onContextualUserChange"
                      v-model="selectedContextualUser"
                      aria-describedby="contextTotal"
                    >
                      <optgroup v-for="(listOfPeers, optionLabel) in myPeerDropdownGroups" :label="optionLabel">
                        <option v-for="peer in listOfPeers" :value="peer.id">{{peer.name}}</option>
                      </optgroup>
                    </select>
                    <div style="display: flex;justify-content:space-between">
                      <small style="line-height: .60rem;font-size: .60rem" v-if="rollupsTotal && selectedContextualUser != 'empty'" class="form-text">Total: {{rollupsTotal}}</small>
                      <div v-else>&nbsp;</div>
                      <a style="line-height: .60rem;font-size: .60rem" class="form-text"  v-if="selectedContextualRole" href="#" @click.prevent="x => setupSearchDropdown('clear')">
                        Back to my user
                      </a>
                      <div class="nav-item dropdown pb-1 pull-right">

                        <a style="line-height: .60rem;font-size: .60rem" href="#" role="button" id="groupSwitcherDropdown" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                          Switch Role
                        </a>
                        <div class="dropdown-menu" aria-labelledby="groupSwitcherDropdown">
                          <a v-for="role in allRoles" class="dropdown-item" style="cursor:pointer;" @click.prevent="setupSearchDropdown(role.id)">{{role.name}}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showContextualTypes">
                  <a class="form-text mb-1" href="#" @click="onClearContextualType" v-if="selectedContextualType">Show All Types</a>
                  <table>
                    <tr v-for="rollup in itemRollups" :key="rollup.aiType">
                      <td>
                        <div v-if="!selectedContextualType && itemRollups.length > 1">
                          <a
                            href="#" @click="onContextualTypeChange(rollup.aiType)"
                            v-model="selectedContextualType"
                            class="pull-left">
                            {{rollup.aiType}}
                          </a>
                        </div>
                        <div v-else>
                          {{rollup.aiType}}
                        </div>
                      </td>
                      <td class="pl-3">
                        {{rollup.count}}
                      </td>
                    </tr>
                  </table>
                </div>
                </div>
              </div>
            </div>
        </div>

        <div class="full-height" style="overflow-y: auto; position: relative;">
            <transition appear v-on:appear="customAppearHook">
                <div id="action-items-list">
                    <div v-for="item in actionItemsToDisplay" v-bind:key="item.actionItemId">
                        <div :id="'action-item-' + item.actionItemId">
                          <action-item :item="item" :quickSearchText="quickSearchText"></action-item>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</div>
</template>

<script>

import ActionItem from "./ActionItem";
import ActionItemsSearch from "./ActionItemsSearch";

import './types/registered-types';
import $ from "jquery";
import SystemSearchBar from '../framework/SystemSearchBar';
import ActionItemAssignmentModal from "./ActionItemAssignmentModal";
import {userRoles, userRoleMap} from "../user/user-labels";

export default {
    components: { ActionItem, SystemSearchBar },
    data() {
        return {
            title: '',
            quickSearchText: null,
            locallySearchActionItems: null,
            quickSearchDropDownVisible: false,
            myPeers: [],
            selectedContextualUser: null,
            selectedContextualType: null,
            selectedContextualRole: null,
            showContextualTypes: true,
            actionItemTypes: []

        }
    },
    created() {
        this.load();
    },
    computed: {
        ...amfx.map("actionItems", "items,multiSelectedCount,currentSearchParams,itemsCount"),
        ...amfx.map("session", "impersonatedUser, isInternalUser, singleEmployer, roles, myUserId:userId"),
        ...amfx.map('employer', ['employerId', 'amfCode', 'employerName:name']),
        ...amfx.map('participant', ['participantId','fullName']),
        showEmployerLink() {
          return this.employerId && !this.singleEmployer && (this.$route.params.employerId === this.employerId);
        },
        showEmployeeLink()
        {
          return !this.showEmployerLink && (this.$route.params.participantId === this.participantId);
        },
        actionItemsToDisplay() {
          return this.locallySearchActionItems ? this.locallySearchActionItems : this.items;
        },
        myPeerDropdownGroups() {
          if (!this.myPeers || !this.myPeers.length) return null;
          let g = _.groupBy(this.myPeers, 'grouping');
          return g;
        },
        itemRollups() {
          if (!this.items || !this.items.length) return [];
          let grouped = _.groupBy(this.items, i => i.itemType);
          let aiRollups = [];
          Object.keys(grouped).map(k => {
            aiRollups.push({
              aiType: this.actionItemTypes.find(x => x.itemType == k).displayName,
              count: grouped[k].length
            })
          });

          return _.orderBy(aiRollups, ['aiType']);
        },
        allRoles() {
          return _.orderBy(userRoles.filter(x => !x.external), 'name');
        },
        rollupsTotal() {
          if (!this.itemRollups || !this.itemRollups.length) return null;
          return _.sumBy(this.itemRollups, 'count');
        }
    },
    watch: {
        impersonatedUser() {
            this.load();
        },
        quickSearchText(newVal, oldVal) {
          this.quickSearch(newVal, oldVal);
        },
        items() {
          this.quickSearch(this.quickSearchText, null);
        }
    },
    methods: {
        ...amfx.map("actionItems", "refresh,collapseAll,search,loadAssigned,clearMultiSelection,getActionItemTypes,loadAllForRole"),
        hjTag(tagName) {
          hj('tagRecording', [`AI Search: ${tagName}`]);
        },
        async load() {
            this.busy = true;
            this.selectedContextualUser = this.myUserId;
            this.actionItemTypes = await this.getActionItemTypes();
            await this.loadAssigned();
            await this.setupSearchDropdown();
            this.busy = false;
        },
        async showMine() {
            this.hjTag('Clicked Mine');
            this.busy = true;
            this.quickSearchText = null;
            if (this.myPeers.find(x => x.id == this.myUserId)) {
              this.selectedContextualUser = this.myUserId;
              this.showContextualTypes = true;
            } else {
              await this.setupSearchDropdown(null);
              this.selectedContextualUser = this.myUserId;
              this.showContextualTypes = true;
            }
            await this.loadAssigned();
            this.busy = false;
        },
        deselectAll() {
          this.clearMultiSelection(null);
        },
        async reassignMultiple() {
          await modalService.show("action-item-assignment-modal", ActionItemAssignmentModal);
        },
        async showCurrentEmployerItems() {
          if (this.employerId) {
            this.hjTag('Clicked Employer AMF Link');
            this.quickSearchText = null;
            await this.search({ employerId: this.employerId });
            this.clearContextualSearch();
          }
        },
        async showCurrentEmployeeItems() {
          if (this.participantId) {
            this.hjTag('Clicked Employee Name Link');
            this.quickSearchText = null;
            await this.search({ participantId: this.participantId });
            this.clearContextualSearch();
          }
        },
        async showModalSearch() {
            this.hjTag('Clicked Advanced Search');
            const data = await modalService.show("action-items-search", ActionItemsSearch, {});
            if (data) {
                this.busy = true;
                this.quickSearchText = null;
                this.clearContextualSearch();
                await this.search(data);
                this.busy = false;
            }
        },
        customAppearHook() {
            if(this.isInternalUser) return
            let actionItemsOverlay = $("#action-items-overlay");
            this.flashElem(actionItemsOverlay);
        },

        flashElemColor(elem, styleAttr, color) {
            let normColor = elem.css(styleAttr);
            elem.css(styleAttr, color || normColor);
            $.when(this.flashElem(elem))
                .then(function() { elem.css(styleAttr, normColor) });
        },

        flashElem(elem, flashTime = 500, minOpacity = 0) {
            return elem
                .animate({ opacity: minOpacity }, flashTime)
                .animate({ opacity: 1 }, flashTime)
                .animate({ opacity: minOpacity }, flashTime)
                .animate({ opacity: 1 }, flashTime)
                .animate({ opacity: minOpacity }, flashTime)
                .animate({ opacity: 1 }, flashTime);
        },
        quickSearch(newVal, oldVal) {
          if (!newVal || newVal == "")
            this.locallySearchActionItems = null;

          if (!!newVal && newVal !== oldVal) {
            let val = newVal.toString().toLowerCase();

            this.hjTag('Used Quicksearch');

            this.locallySearchActionItems =
              this.items.filter(item => {
                if (item.amfCode && item.amfCode.toLowerCase().includes(val))
                  return true;

                if (item.assignmentText && item.assignmentText.toLowerCase().includes(val))
                  return true;

                if (item.description && item.description.toLowerCase().includes(val))
                  return true;

                if (item.employerName && item.employerName.toLowerCase().includes(val))
                  return true;

                if (item.participantName && item.participantName.toLowerCase().includes(val))
                  return true;

                if (item.actionItemId && item.actionItemId.toString().includes(val)) {
                  return true;
                }
              })
          }
        },
        showQuickSearchDropdown() {
          this.hjTag('Clicked contextual search dropdown');
          this.quickSearchDropDownVisible = !this.quickSearchDropDownVisible;
        },
        clearContextualSearch() {
          this.selectedContextualUser = 'empty';
          this.showContextualTypes = false;
          this.quickSearchDropDownVisible = false;
        },
        async setupSearchDropdown(byRole) {
          if (!this.isInternalUser) return;
          let clearRole = byRole == 'clear';

          if (clearRole) {
            byRole = null;
          }
          this.selectedContextualRole = byRole;
          let peers = [];
          let findMyPeersBaseUrl = 'user/role/byname/';

          let forRoles = this.roles;

          if (!!byRole) {
            forRoles = [byRole];
            this.hjTag('Used Role Switcher');
          }

          for (let i = 0; i < forRoles.length; i++) {
            let formattedRole = userRoleMap[forRoles[i]];
            let myPeers = await romeApi.get(`${findMyPeersBaseUrl}/${forRoles[i]}`, { activeOnly: true});
            myPeers.map(p => {

              let peer = {
                name: p.userId == this.myUserId ? `Mine (${p.firstName} ${p.lastName})` : `${p.firstName} ${p.lastName} (${formattedRole.name})`,
                id: p.userId,
                order: p.userId == this.myUserId ? 3 : 0,
                grouping: p.userId == this.myUserId ? 'Quick Access' : `All Users: ${formattedRole.name}`,
                searchFunction:  async (type) => {
                  await this.search({
                    assignedToId: p.userId,
                    includeContextualItemsForUserId: true,
                    type
                  })
                }
              };

              peers.push(peer);

              return peer;
            });

            peers.push({
              name: `All (${formattedRole.name})`,
              id: `all-${formattedRole.id}`,
              order: 2,
              grouping: 'Quick Access',
              searchFunction: async (type) => {
                await this.loadAllForRole({
                  role: formattedRole.id,
                  type: type
                });
              }
            })

            peers.push({
              name: `Unassigned (${formattedRole.name})`,
              id: formattedRole.id,
              order: 1,
              grouping: 'Quick Access',
              searchFunction: async (type) => {
                await this.search({
                  role: formattedRole.id,
                  type
                });
              }
            })
          }

          peers = _.orderBy(peers, [(item) => {
            return item.order;
          }, 'name'], ['desc', 'asc']);

          peers = _.uniqBy(peers, 'id');

          peers.splice(0, 0, {
            name: '-- Please Select User / Role --',
            id: 'empty',
            grouping: 'Quick Access'
          });

          // If we switched roles, go ahead and perform "All" search
          if (!!byRole) {
            let allByRole = peers.find(x => x.id == `all-${byRole}`);
            this.selectedContextualUser = allByRole.id;
            await allByRole.searchFunction();
          }

          if (clearRole) {
            this.selectedContextualUser = this.myUserId;
            let self = peers.find(x => x.id == this.myUserId);
            await self.searchFunction();
          }

          this.myPeers = peers;
        },
        async onContextualUserChange(e) {
          if (!e.target.value) return;
          this.hjTag('Changed contextual users');
          let { searchFunction } = this.myPeers.find(x => x.id == e.target.value);
          this.showContextualTypes = true;
          this.selectedContextualType = null;
          if (searchFunction && searchFunction instanceof Function) {
            await searchFunction();
          }
        },
        async onContextualTypeChange(aiType) {
          this.hjTag('Changed contextual types');
          this.selectedContextualType = aiType;
          let type = this.actionItemTypes.find(x => x.displayName == aiType).itemType;

          if (this.selectedContextualUser) {
            let { searchFunction } = this.myPeers.find(x => x.id == this.selectedContextualUser);
            if (searchFunction && searchFunction instanceof Function) {
              await searchFunction(type);
            }
          }
        },
        async onClearContextualType() {
          this.hjTag('Cleared contextual types');
          this.selectedContextualType = null;
          let query = {};

          if (this.selectedContextualUser) {
            let { searchFunction } = this.myPeers.find(x => x.id == this.selectedContextualUser);
            await searchFunction(null);
          }
        }
    }
}

</script>

<style lang="scss" scoped>
.action-items {
    background-color: white;
    line-height: 1.5;
    height: 100%;

    width: 100%;
    z-index: 999;
    position: relative;

    h4 {
        color: #1a1a3e;
    }

    .sub-head {
        color: #232353 !important;
    }

    .search-bar {
        color: initial;
    }

    .search-results {
        min-width: initial;
    }

    .quicksearch-dropdown {
      border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .quicksearch-open {
      color: #fff;
      background-color: #6c757d;
    }

}
</style>



// WEBPACK FOOTER //
// src/action-items/ActionItems.vue